import * as React from 'react';
import {Icon} from '@iconify/react';
import classNames from 'classnames';
import {auth} from '../../Firebase/main';


export enum Tabs {
    home = 'home',
    buddies = 'buddies',
}


export interface Tab {
    value: Tabs;
    selected: boolean;
    notifications: number;
    icon: string;
}


export const TabBarComponent: React.FC<{
    selectedTab: Tabs;
    onSelect: (tab: Tabs) => void;
    notifications: { [Tabs.home]: number; [Tabs.buddies]: number };
}> = ({onSelect, selectedTab, notifications}) => {
    const tabs: Tab[] = [
        {
            value: Tabs.home,
            selected: selectedTab === Tabs.home,
            notifications: notifications[Tabs.home],
            icon: 'entypo:home',
        },
        {
            value: Tabs.buddies,
            selected: selectedTab === Tabs.buddies,
            notifications: notifications[Tabs.buddies],
            icon: 'majesticons:users',
        },
    ].filter((item, i) =>
        auth.currentUser || i < 1,
    );

    return (
        <div className={'mvc-tool-bar-component'}>
            {tabs.map(({value, selected, notifications, icon}) => (
                <span
                    key={value}
                    onClick={() => onSelect(value)}
                    className={classNames({
                        selected,
                    })}
                >
          <span
              className={'mvc-tool-bar-component-notification-badge'}
              children={notifications}
              style={{opacity: !!notifications ? 1 : 0}}
          />
          <Icon icon={icon} height={24}/>
        </span>
            ))}
        </div>
    );
};
